module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-12.12fcc45c.mp3";